import { ReferenceDataService } from '@lib/services/reference-data.service';
import { of } from 'rxjs';
import { booleanOptions, eqOperator, fullComparator } from '../../filtre-investisseur-helper';
import { CompositeFiltreCustomBuilder, FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getFiscaliteBuilders(referenceDataService: ReferenceDataService): FiltreBuilder[] {
  return [
    new CompositeFiltreCustomBuilder('FISC', 'FISCAL_IR_NET', 'and', 'foyerFiscal.impotRevenuNet', fullComparator, 'InputEuro', undefined, [
      { fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true },
    ]),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_IMPOT_BRUT',
      'and',
      'foyerFiscal.impotRevenuBrut',
      fullComparator,
      'InputEuro',
      undefined,
      [{ fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true }]
    ),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_IMPOT_TOTAL_AVANT_CREDITS',
      'and',
      'foyerFiscal.impotTotalAvantCreditsImpot',
      fullComparator,
      'InputEuro',
      undefined,
      [{ fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true }]
    ),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_PARTS_FISCALES_NOMBRE',
      'and',
      'foyerFiscal.nbParts',
      fullComparator,
      'InputNumeric',
      undefined,
      [{ fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true }],
      2
    ),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_PLAFOND_EPARGNE_RETRAITE_NON_UTILISE',
      'and',
      'foyerFiscal.plafondEpargneRetraireNonUtilise',
      fullComparator,
      'InputEuro',
      undefined,
      [{ fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true }]
    ),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_REVENU_BRUT_GLOBAL',
      'and',
      'foyerFiscal.revenusBrutGlobal',
      fullComparator,
      'InputEuro',
      undefined,
      [{ fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true }]
    ),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_TAUX_MARGINAL_IMPOSITION',
      'and',
      'foyerFiscal.impotRevenuTauxMarginal',
      fullComparator,
      'Select',
      of(referenceDataService.tauxMarginalOptions),
      [{ fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true }]
    ),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_TOTAL_CREDITS_IMPUTATIONS',
      'and',
      'foyerFiscal.impotRevenuTotalCredit',
      fullComparator,
      'InputEuro',
      undefined,
      [{ fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true }]
    ),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_TOTAL_REDUCTION',
      'and',
      'foyerFiscal.impotRevenuTotalReduction',
      fullComparator,
      'InputEuro',
      undefined,
      [{ fieldPath: 'foyerFiscal.imposableImpotRevenu', operator: 'eq', value: true }]
    ),
    new ItemFiltreCustomBuilder(
      'FISC',
      'FISCAL_IMPOSABLE_IFI',
      'foyerFiscal.imposableImpotFortuneImmo',
      eqOperator,
      'Select',
      of(booleanOptions)
    ),
    new CompositeFiltreCustomBuilder(
      'FISC',
      'FISCAL_IFI_NET',
      'and',
      'foyerFiscal.impotFortuneImmoNet',
      fullComparator,
      'InputEuro',
      undefined,
      [{ fieldPath: 'foyerFiscal.imposableImpotFortuneImmo', operator: 'eq', value: true }]
    ),
  ];
}
